"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOOPS_CONFIGURATION = exports.OpponentPlayCode = exports.PlayCode = void 0;
var PlayCode;
(function (PlayCode) {
    PlayCode["Made2"] = "made2";
    PlayCode["Made3"] = "made3";
    PlayCode["Missed2"] = "missed2";
    PlayCode["Missed3"] = "missed3";
    PlayCode["MadeFreeThrow"] = "madeFreeThrow";
    PlayCode["MissedFreeThrow"] = "missedFreeThrow";
    PlayCode["Foul"] = "foul";
    PlayCode["TechnicalFoul"] = "technicalFoul";
    PlayCode["Turnover"] = "turnover";
    PlayCode["Rebound"] = "rebound";
    PlayCode["OffensiveRebound"] = "offensiveRebound";
    PlayCode["DefensiveRebound"] = "defensiveRebound";
    PlayCode["Assist"] = "assist";
    PlayCode["Steal"] = "steal";
    PlayCode["Block"] = "block";
    PlayCode["Timeout"] = "timeout";
    PlayCode["Timeout30"] = "timeout30";
})(PlayCode = exports.PlayCode || (exports.PlayCode = {}));
var OpponentPlayCode;
(function (OpponentPlayCode) {
    OpponentPlayCode["Made2"] = "made2";
    OpponentPlayCode["Made3"] = "made3";
    OpponentPlayCode["MadeFreeThrow"] = "madeFreeThrow";
    OpponentPlayCode["MissedFreeThrow"] = "missedFreeThrow";
    OpponentPlayCode["Foul"] = "foul";
    OpponentPlayCode["TechnicalFoul"] = "technicalFoul";
    OpponentPlayCode["Turnover"] = "turnover";
    OpponentPlayCode["Rebound"] = "rebound";
    OpponentPlayCode["OffensiveRebound"] = "offensiveRebound";
    OpponentPlayCode["DefensiveRebound"] = "defensiveRebound";
    OpponentPlayCode["Timeout"] = "timeout";
    OpponentPlayCode["Timeout30"] = "timeout30";
})(OpponentPlayCode = exports.OpponentPlayCode || (exports.OpponentPlayCode = {}));
exports.HOOPS_CONFIGURATION = {
    play_codes: Object.values(PlayCode),
    opponent_play_codes: Object.values(OpponentPlayCode),
};
//# sourceMappingURL=definitions.js.map